<template>
  <div>
    <b-row align-v="end">
      <b-col>
        <b-button-group>
          <b-button
            @click="setSearchMode('barcode')"
            :variant="searchMode == 'barcode' ? 'primary' : 'outline-primary'"
            ><i class="fas fa-barcode" /> Pesquisar por código (F1)</b-button
          >
          <b-button
            @click="setSearchMode('search')"
            :variant="searchMode == 'search' ? 'primary' : 'outline-primary'"
            ><i class="fas fa-search" /> Pesquisa manual (F2)</b-button
          >
        </b-button-group>
      </b-col>
      <b-col>
        <label class="mb-0" for="customerName">Informar Cliente (F7) </label>
        <b-input-group>
          <b-form-input
            id="customerName"
            @click="$refs.PdvClientSearchModal.open()"
            readonly
            :value="customer"
          />
          <b-input-group-append v-if="order.client_id">
            <b-button @click="removeClient()" variant="outline"
              ><i class="fas fa-times"
            /></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <div class="row mt-4">
      <div class="col">
        <PdvProductSearch v-if="searchMode == 'search'" />
        <PdvProductBarcodeSearch v-if="searchMode == 'barcode'" />
      </div>
      <div class="col">
        <PdvOrder @finishOrder="handleFinishOrder()" />
      </div>
    </div>
    <PdvFinishModal ref="PdvFinishModal" @store="handleStore()" />
    <PdvClientSearchModal
      ref="PdvClientSearchModal"
      @input="setCustomer($event)"
      v-model="form.customer"
    />
  </div>
</template>

<script>
import PdvOrder from "@/components/pdv/sections/PdvOrder";
import PdvProductSearch from "@/components/pdv/sections/PdvProductSearch";
import PdvProductBarcodeSearch from "@/components/pdv/sections/PdvProductBarcodeSearch";
import PdvFinishModal from "@/components/pdv/sections/PdvFinishModal";
import ClientSearch from "@/components/ClientSearch";
import ClientStats from "@/components/sections/person/ClientStats";
import PdvClientSearchModal from "@/components/sections/pdv/PdvClientSearchModal.vue";

export default {
  // todo
  // excluir item
  // formatar mensagem de sucesso

  // ******
  // adicionar cliente

  components: {
    PdvOrder,
    PdvProductSearch,
    PdvProductBarcodeSearch,
    PdvFinishModal,
    ClientSearch,
    ClientStats,
    PdvClientSearchModal
  },

  data: () => ({
    searchMode: "barcode",
    form: {
      unidentified_client: 1,
      customer: {
        name: "Consumidor Final"
      },
      onSetDueDays: 0
    },
    error: null
  }),

  created() {
    window.addEventListener("keydown", e => {
      if (e.key == "F1") {
        e.preventDefault();
        this.setSearchMode("barcode");
      }

      if (e.key == "F2") {
        e.preventDefault();
        this.setSearchMode("search");
      }

      if (e.key == "F12") {
        e.preventDefault();
        this.handleFinishOrder();
      }
      if (e.key == "F7") {
        e.preventDefault();
        this.$refs.PdvClientSearchModal.open();
      }
    });

    this.$store.commit("pageHasLoaded");
  },

  computed: {
    order() {
      return this.$store.state.orderForm.order;
    },

    netTotal() {
      return this.$store.getters["orderForm/netTotal"];
    },
    customer() {
      return this.$store.getters["orderForm/customer"];
    }
  },

  methods: {
    setCustomer(customer) {
      this.$store.commit("orderForm/setClient", customer);
    },

    removeClient() {
      this.$store.commit("orderForm/removeClient");
    },

    onSetDueDays(event) {
      this.form.onSetDueDays = event;
    },
    handleFinishOrder() {
      this.$refs.PdvFinishModal.open();
    },

    setSearchMode(searchMode) {
      this.searchMode = searchMode;
    },

    async handleStore() {
      //this.setOrderBillsValue();

      this.$store.commit("showLoading");

      await this.$store
        .dispatch("orderForm/storeOrder", this.order)
        .then(response => {
          this.reset();
          this.$store.commit("orderForm/reset");
          this.$refs.PdvFinishModal.success();
        })
        .catch(error => {
          this.$store.commit("orderForm/setError", error);
        });

      this.$store.commit("hideLoading");
    },

    reset() {
      this.$store.commit("orderForm/reset");
      this.error = null;
    }
  }
};
</script>

<style></style>
